module.exports = __webpack_public_path__ + "img/latin-lawyer-2.4068a0cf.png";